/** The Status Id is used several times in the code
 * the mixin allows the method to be called depending on the entityType and color of the status
 * icon
 * @mixin */

export default {
  methods: {
    /**
     * Helper to use when entityType is equal to namespace
     * @param {int} statusId - Id of status
     * @param {string} entityType - the name/namespace of the entity to determine color type
     */
    getStatusClass(statusId, entityType) {
      const status = {
        Instrument: { 1: 'text-warning', 2: 'text-success', 3: 'status-closed' },
        Property: { 1: 'text-success', 2: 'status-closed' },
        Service: { 1: 'text-warning', 2: 'status-closed' },
      };

      return (status[entityType] && status[entityType][statusId]) || 'd-none';
    },
    /*
     * Helper to use with Services to see if status is Open or is a new service
     * @param {int} statusId - Id of status
     */
    isServiceNewOrOpen(statusId) {
      return !statusId || statusId === 1;
    },
  },
};
